if (!customElements.get('tabbed-collections')) {
  customElements.define(
    'tabbed-collections',
    class TabbedCollections extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.boundSelectTab = this.onTabClick.bind(this);
        this.boundKeydown = this.onKeydown.bind(this);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.boundSelectTab);
          tab.addEventListener('keydown', this.boundKeydown);
        });
      }

      disconnectedCallback() {
        if (this.tabs) {
          this.tabs.forEach((tab) => {
            tab.removeEventListener('click', this.boundSelectTab);
            tab.removeEventListener('keydown', this.boundKeydown);
          });
        }
      }

      onTabClick(event) {
        this.selectTab(event.currentTarget);
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.querySelector(`#${tab.getAttribute('aria-controls')}`).hidden = !selected;
        });
      }

      onKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        this.selectTab(this.tabs[nextIndex]);
        this.tabs[nextIndex].focus();
      }
    }
  );
}
